import { Component, OnInit, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { NavigationActions } from '@next/core-lib/navigation';
import { Store } from '@ngrx/store';

import { AppState, SiteState } from './shared/models';
import { openTermsAndConditionsDialog } from './store/actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly appStore = inject<Store<AppState>>(Store);
  private readonly locale = inject(LocaleService);

  readonly navigationItems = [
    {
      relativeUrl: '/',
      label: 'Dashboard',
      icon: 'dashboard',
    },
  ];
  direction$ = this.locale.direction$;

  ngOnInit(): void {
    this.appStore.dispatch(openTermsAndConditionsDialog());
    this.store.dispatch(
      NavigationActions.setNavigationItems({
        navigationItems: this.navigationItems,
      }),
    );
  }
}
